export default __webpack_public_path__ + "static/media/ArrowUp.7ef9f733.svg";